module.exports = __webpack_public_path__ + "img/a1-s26.5c826aca.jpg";